<nb-card accent="success">
  <nb-card-header>
    <div class="d-flex">
      <div class="flex-grow-1 d-flex align-items-center justify-content-center">
        <nb-icon icon="search-outline"></nb-icon>
        <div class="ml-2" i18n>Viewing Insight: {{ insight.id }}</div>
      </div>
      <button nbButton class="ml-3" (click)="close()">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>
  <nb-card-body style="min-width: 750px">
    <strong class="text-uppercase" i18n>Insight Details</strong>
    <hr />
    <dl class="row">
      <dt class="col-4" i18n>Name</dt>
      <dd *ngIf="!insight_name_validator" class="col-8">{{ insight.name }}</dd>
      <dd *ngIf="insight_name_validator" class="col-8" i18n>{{ insight.name }} (invalid insight name)</dd>
    </dl>
    <dl class="row">
      <dt class="col-4" i18n>Created By</dt>
      <dd *ngIf="insight.created_by !== null" class="col-8">
        {{ insight.created_by }}
      </dd>
      <dd *ngIf="insight.created_by === null" class="col-8" i18n>Unknown</dd>
    </dl>
    <dl class="row">
      <dt class="col-4" i18n>Created On</dt>
      <dd class="col-8">{{ formatted_created_date }}</dd>
    </dl>
    <dl class="row">
      <dt class="col-4" i18n>Last Updated By</dt>
      <dd *ngIf="insight.last_updated_by !== null" class="col-8">
        {{ insight.last_updated_by }}
      </dd>
      <dd *ngIf="insight.last_updated_by === null" class="col-8" i18n>Unknown</dd>
    </dl>
    <dl class="row">
      <dt class="col-4" i18n>Last Updated On</dt>
      <dd class="col-8">{{ formatted_updated_date }}</dd>
    </dl>
    <dl class="row">
      <dt class="col-4" i18n>Description</dt>
      <dd class="col-8">{{ insight.description }}</dd>
    </dl>

    <strong class="text-uppercase" i18n>Actions Details</strong>
    <hr />
    <dl class="row">
      <dt class="col-4" i18n>Activated</dt>
      <dd class="col-8">
        <nb-checkbox status="info" [checked]="insight.enabled" disabled></nb-checkbox>
      </dd>
    </dl>
    <dl class="row" *ngIf="insight.schedule_seconds !== null">
      <dt class="col-4" i18n>Schedule</dt>
      <dd class="col-8">{{ scheduleLabel }}</dd>
    </dl>
    <dl class="row" *ngIf="insight.next_run_time !== null">
      <dt class="col-4" i18n>Next Run Time</dt>
      <dd class="col-8">{{ formatted_next_run_time }}</dd>
    </dl>
    <dl class="row" *ngIf="insight.start_date !== null">
      <dt class="col-4" i18n>Start Time</dt>
      <dd class="col-8">{{ formatted_start_date }}</dd>
    </dl>
    <dl class="row" *ngIf="insight.end_date !== null">
      <dt class="col-4" i18n>End Time</dt>
      <dd class="col-8">{{ formatted_end_date }}</dd>
    </dl>
    <dl class="row">
      <dt *ngIf="insight?.status" class="col-4" i18n>Status</dt>
      <dd *ngIf="insight?.status" class="col-8">
        {{ insight.status | titlecase }}
      </dd>
    </dl>
    <dl class="row">
      <dt class="col-4" i18n>Trigger Query:</dt>
      <dd *ngIf="insight.query" class="col-8">
        <ngx-codemirror
          #codeeditor
          id="query"
          name="query"
          [(ngModel)]="insight.query"
          [options]="{
            lineNumbers: true,
            theme: 'default',
            mode: 'sql',
            readOnly: 'true'
          }"
        ></ngx-codemirror>
      </dd>
    </dl>
  </nb-card-body>
</nb-card>
